import { useEffect, useState } from "react";
import { useReducedMotion } from "framer-motion";
import { idYoutube } from "./embeds";

// Fondo de portada con video ambiental de YouTube (sin sonido, en bucle,
// sin controles). El poster queda siempre detrás como respaldo: se ve mientras
// carga, si el usuario prefiere movimiento reducido, y si el video no puede
// reproducirse (la capa solo se revela cuando el reproductor confirma via
// postMessage que está reproduciendo).
export default function FondoVideoAmbient({ urlYoutube, poster, alt = "" }) {
  const reduce = useReducedMotion();
  const [reproduciendo, setReproduciendo] = useState(false);
  const id = idYoutube(urlYoutube || "");

  useEffect(() => {
    if (!id || reduce) return undefined;
    const alMensaje = (e) => {
      if (!e.origin.endsWith("youtube.com") && !e.origin.endsWith("youtube-nocookie.com")) return;
      try {
        const data = typeof e.data === "string" ? JSON.parse(e.data) : e.data;
        if (data?.event === "onStateChange" && data?.info === 1) setReproduciendo(true);
      } catch {
        /* mensajes ajenos al reproductor */
      }
    };
    window.addEventListener("message", alMensaje);
    return () => window.removeEventListener("message", alMensaje);
  }, [id, reduce]);

  return (
    <div
      style={{ position: "absolute", inset: 0, zIndex: 0, overflow: "hidden", containerType: "size" }}
    >
      {poster && (
        <img
          src={poster}
          alt={alt}
          style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }}
        />
      )}
      {id && !reduce && (
        <iframe
          src={`https://www.youtube-nocookie.com/embed/${id}?autoplay=1&mute=1&loop=1&playlist=${id}&controls=0&playsinline=1&rel=0&modestbranding=1&iv_load_policy=3&disablekb=1&fs=0&enablejsapi=1`}
          title=""
          tabIndex={-1}
          aria-hidden="true"
          allow="autoplay; encrypted-media"
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "max(100.2cqw, 178cqh)",
            height: "max(100.2cqh, 56.4cqw)",
            border: 0,
            pointerEvents: "none",
            opacity: reproduciendo ? 1 : 0,
            transition: "opacity 1.2s ease",
          }}
        />
      )}
    </div>
  );
}
